import LoadingIndicator from 'src/components/ui/loading_indicator';
import cls from 'src/utils/class_names';
import styles from './index.sass';

function LoadingOverlay({ className = '', dim = false }) {
	return (
		<div className={cls(styles.loadingOverlay, dim && styles.dim, className)}>
			<LoadingIndicator />
		</div>
	);
}

export default LoadingOverlay;
